import React from "react";
import T from "prop-types";
import { Field } from "redux-form";
import { FormRow, CheckGroup, Check } from "MODULES/shared/components/Forms";
import { Col } from "react-bootstrap";
import AuditedNoteTooltip from "MODULES/shared/components/NoteTooltip/AuditedNoteTooltip";
import {
  CUSTOMER_QC_PREAPPROVAL_REQUIRED,
  EXPORT_COMPLIANCE_HOLD
} from "MODULES/SalesOrders/constants";
import { properCase } from "LIB/formatters/text";

export default function Flags({
  disabled,
  hazmatFee,
  change,
  canEditQcPreapproval,
  canEditHazmatFlags,
  canEditExportComplianceHold,
  disableQcPreapproval,
  lineItem
}) {
  const handleHazmatFee = () => {
    if (!hazmatFee) {
      change("hazmat_fee", "75");
    }
  };

  return (
    <React.Fragment>
      <FormRow>
        <Col md={6}>
          <CheckGroup title="Line Hazmat" justified>
            <Field
              name="hazmat"
              component={Check}
              label="Hazmat"
              icon="fa-warning"
              disabled={disabled || !canEditHazmatFlags}
              onChange={handleHazmatFee}
            />
            <Field
              name="bio_hazmat"
              component={Check}
              label="Bio-Hazmat"
              icon="fa-flask"
              disabled={disabled || !canEditHazmatFlags}
              onChange={handleHazmatFee}
            />
          </CheckGroup>
        </Col>
        <Col md={6}>
          <CheckGroup
            title={[
              "QC Pre-Approval",
              <AuditedNoteTooltip
                field={CUSTOMER_QC_PREAPPROVAL_REQUIRED}
                obj={lineItem}
              />
            ]}
            justified
          >
            <Field
              name={CUSTOMER_QC_PREAPPROVAL_REQUIRED}
              component={Check}
              label="Required"
              disabled={
                (disabled && !canEditQcPreapproval) || disableQcPreapproval
              }
            />
          </CheckGroup>
        </Col>
      </FormRow>
      <FormRow>
        <Col md={6}>
          <CheckGroup
            title={[
              properCase(EXPORT_COMPLIANCE_HOLD),
              <AuditedNoteTooltip
                field={EXPORT_COMPLIANCE_HOLD}
                obj={lineItem}
              />
            ]}
            justified
          >
            <Field
              name={EXPORT_COMPLIANCE_HOLD}
              component={Check}
              label="Required"
              disabled={disabled && !canEditExportComplianceHold}
            />
          </CheckGroup>
        </Col>
      </FormRow>
    </React.Fragment>
  );
}

Flags.propTypes = {
  disabled: T.bool,
  change: T.func,
  canEditQcPreapproval: T.bool,
  canEditHazmatFlags: T.bool,
  canEditExportComplianceHold: T.bool,
  disableQcPreapproval: T.bool,
  hazmatFee: T.string,
  lineItem: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/PartDetails/Flags.jsx